export default "/assets/website/images/offer_empty.svg?b0f84d294b7c11ac339b6ceb41578f2d";